import React from 'react'
import styled from 'styled-components'
import { useLocation, useSearchParams } from 'react-router-dom'
import Banner from 'components/_UI/Banner'
import Button from 'components/_UI/Button'
import { FullyCentered } from 'styled/alignment/Center'
import { REFUND_REQUESTS_PATH, REFUND_REQUESTS_TAB_PARAM, useRefundRequestsOptional } from 'context/refundRequests/RefundRequests'
import paths from 'routes/paths'
import colors from 'theme/colors'
import breakpoints from 'theme/breakpoints'

/**
 * Pedidos de estorno esperando resposta, em todas as páginas do painel e sem
 * botão de fechar: some quando o último é respondido. Na própria aba de
 * pedidos de estorno ele sairia do lugar só para repetir a lista.
 */
export default function RefundRequestsBanner() {
    const refundRequests = useRefundRequestsOptional()
    const location = useLocation()
    const [searchParams] = useSearchParams()

    const pendingCount = refundRequests?.pendingCount || 0
    const onTheTab = location.pathname === paths.dashboard.orders && searchParams.has(REFUND_REQUESTS_TAB_PARAM)

    if (!refundRequests?.enabled || pendingCount === 0 || onTheTab) return null

    const title = pendingCount === 1
        ? '1 pedido de estorno esperando sua resposta'
        : `${pendingCount} pedidos de estorno esperando sua resposta`

    const waiting = waitingFor(refundRequests.oldestPendingAt)

    return (
        <Banner
            type='warning'
            textColor={colors.night}
            iconColor={colors.night}
            title={title}
            text={[
                waiting && `${pendingCount === 1 ? 'Ele chegou' : 'O mais antigo chegou'} há ${waiting}.`,
                'Responda rápido: o comprador está esperando para saber se terá o dinheiro de volta.',
            ].filter(Boolean).join(' ')}
            rightSlot={() => (
                <ButtonContainer>
                    <Button marginBottom={0} variant='orange' path={REFUND_REQUESTS_PATH}>
                        Responder
                    </Button>
                </ButtonContainer>
            )}
        />
    )
}

/** "5 minutos", "3h", "2 dias": desde quando o pedido mais antigo espera. */
function waitingFor(since) {
    if (!since) return null

    const minutes = Math.max(1, Math.floor((Date.now() - new Date(since).getTime()) / 60000))

    if (minutes < 60) return `${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`

    const hours = Math.floor(minutes / 60)

    if (hours < 24) return `${hours}h`

    const days = Math.floor(hours / 24)

    return `${days} ${days === 1 ? 'dia' : 'dias'}`
}

const ButtonContainer = styled(FullyCentered)`
    width: 100%;

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 200px;
    }
`
